"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDateString = void 0;
const moment_1 = __importDefault(require("moment"));
const parseDateString = (dateStr) => {
    // Handle null, undefined, empty string, or "Invalid date"
    if (!dateStr || dateStr === "Invalid date") {
        return Date.now(); // Return current timestamp as fallback
    }
    try {
        // Parse the date string to UTC timestamp to match measurement timestamps
        const timestamp = moment_1.default.utc(dateStr, "MM/DD/YYYY HH:mm").valueOf();
        if (isNaN(timestamp)) {
            console.warn(`Invalid date string: "${dateStr}", using current time`);
            return Date.now();
        }
        return timestamp;
    }
    catch (error) {
        console.warn(`Error parsing date string: "${dateStr}", using current time`, error);
        return Date.now();
    }
};
exports.parseDateString = parseDateString;
